export const formatUserDisplayName = (
  firstName?: string, // in SPM this is just name, there is no last name
  lastName?: string,
  emailAddress?: string,
) => {
  const nameParts = [firstName, lastName].filter((text) => text && text.length > 0);

  if (emailAddress?.includes('@deleted.contact')) {
    return 'Deleted';
  }

  if (nameParts.length === 0 && emailAddress) {
    return emailAddress;
  }

  if (nameParts.length === 0) {
    return undefined;
  }

  return nameParts.join(' ');
};
